module.exports = __webpack_public_path__ + "static/img/index1.1c24bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/school/index1.png
// module id = B8KP
// module chunks = 1